module.exports = __webpack_public_path__ + "img/zarinpal.3642e7e8.svg";